import { action } from 'satcheljs';
import { orchestrator } from 'satcheljs';
import {
    processAutoRunWaitingQueue,
    terminateUiLessExtendedAddinCommand,
    IAddinCommand,
    isAutoRunAddinCommand,
    InvokeAppAddinCommandStatusCode,
} from 'owa-addins-store';

let onUILessExecutionCompleted = action(
    'onUILessExecutionCompleted',
    (
        addinCommand: IAddinCommand,
        controlId: string,
        hostItemIndex: string,
        args: OSF.EventCompletedArgs,
        status: number
    ) => ({
        addinCommand: addinCommand,
        controlId: controlId,
        hostItemIndex: hostItemIndex,
        args: args,
        status: status,
    })
);

orchestrator(onUILessExecutionCompleted, actionMessage => {
    const completedContext = actionMessage.args ? actionMessage.args.completedContext : undefined;
    const isAutoRunAddin = isAutoRunAddinCommand(actionMessage.addinCommand);

    terminateUiLessExtendedAddinCommand(
        actionMessage.controlId,
        actionMessage.hostItemIndex,
        actionMessage.status,
        completedContext
    );

    if (isAutoRunAddin && actionMessage.status == InvokeAppAddinCommandStatusCode.Success) {
        processAutoRunWaitingQueue(actionMessage.hostItemIndex);
    }
});

export default onUILessExecutionCompleted;
